import { HotelReservedCardType } from "@website/accommodation-ui/hotel-reserve-rooms-layout/hotel-reserve-room-layout.types";
import {
  MaterialIcon,
  MaterialIconPropertiesType
} from "@website/icons/material";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import upperFirst from "lodash-es/upperFirst";
import { useRouter } from "next/router";
import { memo } from "react";

const Component = ({
  facilities
}: Pick<HotelReservedCardType, "facilities">) => {
  const router = useRouter();
  return (
    <div className="p-6">
      {facilities?.map((facility) => (
        <div
          className="text-subtitle-2 flex flex-row items-center gap-4 py-2"
          key={facility.title}
        >
          <div>
            <MaterialIcon
              name={
                (facility.icon as MaterialIconPropertiesType["name"]) ||
                "check_box"
              }
              variant="outlined"
            />
          </div>
          <span>
            {upperFirst(
              numberConvert(facility.title, { locale: router.locale })
            )}
          </span>
        </div>
      ))}
    </div>
  );
};
export const HotelReserveCardDetailFacilities = memo(Component, deepCompare);
